var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContragents({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8569 14.4286V2.99998C10.8569 2.6211 10.7064 2.25774 10.4385 1.98983C10.1706 1.72192 9.80724 1.57141 9.42836 1.57141H6.57122C6.19234 1.57141 5.82898 1.72192 5.56107 1.98983C5.29316 2.25774 5.14265 2.6211 5.14265 2.99998V14.4286M2.2855 4.42855H13.7141C14.5031 4.42855 15.1426 5.06815 15.1426 5.85713V13C15.1426 13.789 14.5031 14.4286 13.7141 14.4286H2.2855C1.49653 14.4286 0.856934 13.789 0.856934 13V5.85713C0.856934 5.06815 1.49653 4.42855 2.2855 4.42855Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContragents);
export default __webpack_public_path__ + "static/media/Contragents.14387fa0591a269f1e42d03d693741a4.svg";
export { ForwardRef as ReactComponent };